import axios from "axios";

const axiosService = axios.create();

// Interceptor para manejar errores 401 (autenticación no válida)
axiosService.interceptors.response.use(
  (response) => response, // Si la respuesta es exitosa, la devuelve
  (error) => {
    if (error.response && error.response.status === 401) {
      if (window.location.pathname !== 'login') {
        window.location.href = "/login"; // Redirige a login si hay un 401
      }
    }
    return Promise.reject(error); // Rechaza el error para manejo posterior
  }
);

// Interceptor para adjuntar el token en cada solicitud
axiosService.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Recupera el token almacenado
    if (!config.headers) {
      config.headers = {};
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Agrega el token al header
    }

    const method = config.method?.toLowerCase();
    if (['post', 'patch', 'put'].includes(method)) {
      config.headers['Content-Type'] = 'application/json'; // Asegura el tipo de contenido
    }
    console.log("Request headers: ", config.headers);
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosService;